import { Modal, Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { getImageByFileName } from "../../services/academicService";

const ImagePreviewModal = ({ show, onClose, fileName }) => {
  const [imageData, setImageData] = useState(null);

  async function fetchImage() {
    if (!fileName) return;

    try {
      const res = await getImageByFileName(fileName);
      setImageData(res);
    } catch (error) {
      console.error("Error fetching image data:", error);
    }
  }

  useEffect(() => {
    if (show && fileName) {
      fetchImage();
    }
  }, [show, fileName]);

  const handleDownload = async () => {
    if (!imageData?.fileUrl) return;

    try {
      const response = await fetch(imageData.fileUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      // ✅ Extract clean filename from full path
      const cleanFileName = fileName.split("/").pop();
      a.download = cleanFileName || "download";

      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header>
        <Modal.Title>File Preview</Modal.Title>
        <Button variant="" className="btn-close" onClick={onClose} />
      </Modal.Header>

      <Modal.Body>
        {imageData ? (
          <img
            src={imageData?.fileUrl}
            alt="Preview"
            style={{ width: "100%", borderRadius: "8px" }}
          />
        ) : (
          <div className="text-center p-4">Loading preview...</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant="danger light">
          Close
        </Button>
        <Button variant="primary" onClick={handleDownload}>
          Download
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImagePreviewModal;
